import SVGIcon, { type SVGIconProps } from "@ch/components/Icons/SVGIcon";
import type { FC } from "react";

type DangerIconProps = Partial<SVGIconProps>;

const DangerIcon: FC<DangerIconProps> = (props) => {
  return (
    <SVGIcon height="66" viewBox="0 0 66 66" width="66" {...props}>
      <path
        d="M32.6152 24.875V38.4167"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
      />
      <path
        d="M32.615 58.4854H16.2025C6.80462 58.4854 2.87753 51.7688 7.42753 43.5625L15.8775 28.3417L23.84 14.0417C28.6609 5.34792 36.5692 5.34792 41.39 14.0417L49.3525 28.3688L57.8025 43.5896C62.3525 51.7958 58.3984 58.5125 49.0275 58.5125H32.615V58.4854Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
      />
      <path
        d="M32.5996 46.542H32.6239"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
      />
    </SVGIcon>
  );
};

export default DangerIcon;
